module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAALBAMAAABSacpvAAAAHlBMVEUAAAD///////////////////////////////////8kfJuVAAAACnRSTlMAESIzVWaImczuWiDFgQAAAC5JREFUCNdjYAADRgEIzSDhABVohQkEIAmowQTYC2AqymEq2AthWiqhWhiYwSQABYYGEUhtHDIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/v_white.png
// module id = 655
// module chunks = 0